import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TVerifyCompanyMicroDepositsRequestSchema,
  TVerifyCompanyMicroDepositsResponseSchema,
} from "./verifyCompanyMicroDeposits.schema";

export const verifyCompanyMicroDeposits =
  (axios: IAxiosInstance) =>
  async (body: TVerifyCompanyMicroDepositsRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TVerifyCompanyMicroDepositsResponseSchema>
    >("/companies/microdeposits/verify", body);

    return response.data;
  };
